<h2 mat-dialog-title class="warn-title">Tutor cancelled</h2>

<div mat-dialog-content>
  <div class="tw:text-xs tw:text-[#888] tw:mb-3">This completes this session report and no further actions are required.</div>

  <div class="tw:w-full">
    <label class="field__label">Reason</label>
    <select class="field__control tw:w-full" [(ngModel)]="reason" required>
      <option value="">-- Select --</option>
      @for (r of reasons; track r) {
        <option [value]="r">{{ r }}</option>
      }
    </select>
    <span class="field__hint tw:text-[#c00] tw:text-[10px] tw:font-semibold">* required</span>
  </div>

  <label class="field__label">Comments</label>
  <textarea class="field__control tw:w-full" [(ngModel)]="comments" rows="4" placeholder="Add a comment…"></textarea>
  <span class="field__hint tw:text-[#c00] tw:text-[10px] tw:font-semibold">* required</span>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="warn" [disabled]="!isValid" (click)="submit()">Submit</button>
</div>
